import React from "react";

export default function Enriched({ data }) {
    const rows = data ?? [];

    // Convert "company_name" → "Company Name"
    const toTitleCase = (value) =>
        (value ?? "")
            .toString()
            .replace(/[_\-]+/g, " ")
            .trim()
            .split(/\s+/)
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(" ");

    return (
        <table className="hc-table" style={{ width: "100%", fontSize: "12px" }}>
            <tbody>
            {rows.map((r, i) => (
                <tr className="hc-row" key={i}>
                    <td className="hc-desc" title={r.state} style={{ padding: "4px 6px" }}>
                        {r.type}
                    </td>
                    <td style={{ color: r.highlight === true ? "#ef6c00" : "inherit", padding: "4px 6px" }}>
                        {r.value}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}
